import React from 'react';
import { BarChart } from '@wix/design-system';
export const VisualRepresentationWidget = _ref => {
  let {
    data
  } = _ref;
  let chartItems = [];
  const jsonDataObj = data ? JSON.parse(JSON.stringify(data).trim()) : {};
  if (jsonDataObj) {
    chartItems = Object.entries(jsonDataObj).map(_ref2 => {
      var _ref3;
      let [description, value] = _ref2;
      return {
        value: parseInt((_ref3 = value + '') == null ? void 0 : _ref3.replace('%', ''), 10),
        label: `${value}%`,
        labelShort: `${value}%`,
        descriptionInfo: `${description} ${value}% `,
        description
      };
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BarChart, {
    items: chartItems
  }));
};
export const VISUAL_REPRESENTATION_WIDGET = 'VISUAL_REPRESENTATION_WIDGET';
//# sourceMappingURL=VisualRepresentationWidget.js.map